import { configureStore } from '@reduxjs/toolkit';
import navigationReducer from './slices/navigationSlice';
import servicesReducer from './slices/servicesSlice';
import contactReducer from './slices/contactSlice';

export const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    services: servicesReducer,
    contact: contactReducer,
  },
});

// Export types for TypeScript support
export default store;
